import React from 'react';
import { Tooltip } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

const FloatingToolbar = ({ onCommentClick }) => {
  return (
    <Tooltip title="Comments" placement="left">
      <button
        type="button"
        onClick={onCommentClick}
        style={{
          position: 'fixed',
          right: 20,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1000,
          width: 48,
          height: 48,
          borderRadius: '50%',
          background: '#5A52A3',
          border: '2px solid transparent',
          boxShadow: '0 4px 14px rgba(90, 82, 163, 0.35)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'border-color 0.15s, box-shadow 0.15s, transform 0.15s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = '#D4AF37';
          e.currentTarget.style.boxShadow = '0 6px 18px rgba(212, 175, 55, 0.4)';
          e.currentTarget.style.transform = 'translateY(-50%) scale(1.08)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = 'transparent';
          e.currentTarget.style.boxShadow = '0 4px 14px rgba(90, 82, 163, 0.35)';
          e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
        }}
        aria-label="Toggle comments"
      >
        <ChatBubbleOutlineIcon sx={{ color: '#fff', fontSize: 22 }} />
      </button>
    </Tooltip>
  );
};

export default FloatingToolbar;
